/**
 * Pure helpers behind the staff Models page, kept out of the component
 * file so it exports only components.
 */

import type { ModelResponse, TeamModelAdminRow } from '@/api/generated/model'

/** Which dialog the staff Models page has open, keyed by model id, never by a copy of the model. */
export type OpenDialog =
  | { kind: 'create' }
  | { kind: 'edit'; modelId: string }
  | { kind: 'delete'; modelId: string }
  | null

/**
 * The model an open edit or delete dialog is about, as the list holds it
 * NOW. An alias add, remove or promote refetches the list, and the open
 * editor must render the result rather than the row copied when the
 * dialog opened (Devin BUG_0001 on PR #621). Undefined when no model
 * dialog is open or the model has left the list, which closes the dialog.
 */
export function selectedModel(
  dialog: OpenDialog,
  rows: readonly TeamModelAdminRow[],
): ModelResponse | undefined {
  if (dialog === null || dialog.kind === 'create') return undefined
  const row = rows.find((candidate) => candidate.model.id === dialog.modelId)
  return row === undefined ? undefined : row.model
}

/** Where the primary route sends traffic, in one line. */
export function servesLabel(row: TeamModelAdminRow): string {
  const target = row.forwards_to
  if (row.route === null || target === null) return 'No gateway route'
  const wire = target.provider_model === null ? '' : ` as ${target.provider_model}`
  if (target.catalog_slug !== null) return `Catalog ${target.catalog_slug}${wire}`
  return `${target.upstream_id ?? row.route}${wire}`
}
